export default __webpack_public_path__ + "static/media/nossos_convidados.dfa59d68.png";